import styled from 'styled-components';

const StyledSlider = styled.input`
  appearance: none;
  width: 100%;
  height: 8px;
  border-radius: 4px;
  outline: none;
  transition: opacity 0.2s;
  background: transparent;
  z-index: 5;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }

  &::-webkit-slider-thumb {
    appearance: none;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${(props) => props.theme.colors.brandBlue};
    cursor: pointer;
  }

  ::-moz-range-thumb {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: ${(props) => props.theme.colors.brandBlue};
    cursor: pointer;
  }
`;

export default StyledSlider;
